module.exports = __webpack_public_path__ + "static/media/Wifi.1ad2b966.png";